import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { Router } from '@angular/router';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EcomValidator } from 'src/app/ecom-services/ecom-validation';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import { HttpResponse } from '@angular/common/http';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';

@Component({
  selector: 'app-ecom-forgot-password',
  templateUrl: './ecom-forgot-password.component.html',
  styleUrls: ['./ecom-forgot-password.component.scss']
})
export class EcomForgotPasswordComponent implements OnInit {
  // component class properties
  public userForm: FormGroup;
  errorMessage: any;
  isOtpVerified = false;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  selectedCountryISO: any = CountryISO.Malaysia;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];
  timerOn: any;
  resendOTP: any;
  timeoutFunc: any;
  showOtp = false;
  redirect = false;
  sentOTP = false;
  passwordChanged = false;
  userId:any = undefined;
  // constructor to inject the class objects
  constructor(private eComGoogleAnalytics:EComGoogleAnalytics,public formBuilder: FormBuilder, public ecomservice: EComService,
    private webstorage: EComWebStorage, public router: Router, public cookie: EcomCookies) { }

  // component initialize and load the required data
  ngOnInit() {
    let gTag = {
      'event':'screen_view',
      'screen_name':'forgot password'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    if(!this.webstorage.sessionSt_is_session_valid){
      this.router.navigate(['home']);
    }
    this.LoadPage();
  }

  initPage() {
    //this.selectCountyCode();
    this.userForm = this.formBuilder.group({
      pin1: [''],
      pin2: [''],
      pin3: [''],
      pin4: [''],
      mobile: [''],
      newpassword: ['', Validators.compose([Validators.required, EcomValidator.passwordValidator])],
      confirmpassword: ['', Validators.compose([Validators.required, EcomValidator.passwordValidator])]
    });
  }

  LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.initPage();
        }
      });
    } else {
      this.initPage();
    }
  }

  selectCountyCode() {
    // get user country code to display country suggetion for phone pickup
    if (this.cookie.cookie_country_code) {
      this.setCountryCode();
    } else {
      let url = 'https://api.ipgeolocation.io/ipgeo?apiKey=b610cefa4e2f4665a05094c0bee82ad6'
      this.ecomservice.httpGetOuterResponseHeader(url, '', false).subscribe((response: HttpResponse<any>) => {
        let countrycode = 'MY';
        if (response.status === 200) {
          //this.webstorage.localSt_user_country_code = response.body.country_code2;
          countrycode = response.body.country_code2;
        }
        this.cookie.cookie_country_code = countrycode;
        this.setCountryCode();
      });
    }
  }

  setCountryCode() {
    switch (this.cookie.cookie_country_code) {
      case 'MY':
        this.selectedCountryISO = CountryISO.Malaysia;
        this.preferredCountries = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];
        break;
      case 'SG':
        this.selectedCountryISO = CountryISO.Singapore;
        this.preferredCountries = [CountryISO.Singapore, CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Indonesia, CountryISO.Thailand];
        break;
      case 'ID':
        this.selectedCountryISO = CountryISO.Indonesia;
        this.preferredCountries = [CountryISO.Indonesia, CountryISO.Singapore, CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Thailand];
        break;
      case 'IN':
        this.selectedCountryISO = CountryISO.India;
        this.preferredCountries = [CountryISO.India, CountryISO.Indonesia, CountryISO.Singapore, CountryISO.Malaysia, CountryISO.Australia, CountryISO.Thailand];
        break;
      case 'AU':
        this.selectedCountryISO = CountryISO.Australia;
        this.preferredCountries = [CountryISO.Australia, CountryISO.India, CountryISO.Indonesia, CountryISO.Singapore, CountryISO.Malaysia, CountryISO.Thailand];
        break;
      case 'TH':
        this.selectedCountryISO = CountryISO.Thailand;
        this.preferredCountries = [CountryISO.Thailand, CountryISO.Australia, CountryISO.India, CountryISO.Indonesia, CountryISO.Singapore, CountryISO.Malaysia];
        break;
      default:
        this.selectedCountryISO = CountryISO.Malaysia;
        this.preferredCountries = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];
        break;
    }
  }


  // Method to get the otp to entered mobile number
  onGetOTPClick() {
    this.showOtp = false;
    this.errorMessage = undefined;
    if (!this.userForm.value.mobile || !this.userForm.value.mobile.internationalNumber) {
      this.errorMessage = 'Enter mobile number';
      return;
    } else {
      // check only for mobile number here
      const controls = this.userForm.controls;
      let invalid = false;
      for (const name in controls) {
        if (name === 'mobile' && controls[name].invalid) {
          controls[name].markAsDirty();
          invalid = true;
        }
      }
      if (invalid) {
        this.errorMessage = 'Invalid mobile number';
        return;
      } else {
        const input = {
          ooc_country_dial_code: this.ecomservice.encryptWithKey(this.userForm.value.mobile.countryCode),
          ooc_customer_mobile: this.ecomservice.encryptWithKey(this.userForm.value.mobile.number),
          customer_public_key: this.webstorage.localSt_olar_key,
          customer_client_key: this.webstorage.localSt_client_id
        };
        this.ecomservice.httpPost(EcomNetworkUtils.POST_USER_EXIST, input, '', true).subscribe(response => {
          if (response['status'] === 403) {
            this.router.navigate(['unauthorized']);
          } else {
            if (response.isSuccess) {
              this.sentOTP = true;
              this.userId = response.listValue.ooc_guid;
              this.showOtp = true;
              this.timerOn = true;
              this.timer(119);
            } else {
              this.errorMessage = response.msg;
            }
          }
        });
      }
    }
  }

  // Method to resend the OTP to user mobile number
  onresendOTPClick() {
    this.errorMessage = undefined;
    this.showOtp = false;
    if (!this.userForm.value.mobile || !this.userForm.value.mobile.internationalNumber) {
      this.errorMessage = 'Enter mobile number';
      return;
    } else {
      // check only for mobile number here
      const controls = this.userForm.controls;
      let invalid = false;
      for (const name in controls) {
        if (name === 'mobile' && controls[name].invalid) {
          controls[name].markAsDirty();
          invalid = true;
        }
      }
      if (invalid) {
        this.errorMessage = 'Invalid mobile number';
        return;
      } else {
        const input = {
          ooc_country_dial_code: this.ecomservice.encryptWithKey(this.userForm.value.mobile.countryCode),
          ooc_customer_mobile: this.ecomservice.encryptWithKey(this.userForm.value.mobile.number),
          customer_public_key: this.webstorage.localSt_olar_key,
          customer_client_key: this.webstorage.localSt_client_id
        };
        this.ecomservice.httpPost(EcomNetworkUtils.POST_USER_EXIST, input, '', true).subscribe(response => {
          if (response.isSuccess) {
            this.resendOTP = false;
            this.userId = response.listValue.ooc_guid;
            this.showOtp = true;
            this.timerOn = true;
            this.timer(119);
          } else {
            this.errorMessage = response.msg;
          }
        });
      }
    }
  }

  // Method to handle the change password click event
  onChangePasswordClick() {
    if (this.userForm.invalid) {
      Object.keys(this.userForm.controls).forEach(key => {
        this.userForm.get(key).markAsDirty();
      });
      return;
    } else {
      const input = {
        'ooc_guid': this.userId,
        'newPassword': this.ecomservice.encryptWithKey(this.userForm.value.newpassword),
        'confirmPassword': this.ecomservice.encryptWithKey(this.userForm.value.confirmpassword),
        'customer_client_key': this.webstorage.localSt_client_id,
        'customer_key': this.webstorage.localSt_olar_key
      };
      this.ecomservice.httpPost(EcomNetworkUtils.POST_USER_UPDATE_PASSWORD, input, '', true).subscribe(response => {
        if (response.isSuccess) {
          this.passwordChanged = true;
          this.errorMessage = response.msg;
          this.redirectUser(5);
        } else {
          this.errorMessage = response.msg;
        }
      });
    }
  }

  // Method to handle the back button click
  onBackClick() {
    if (this.webstorage.sessionSt_frompage) {
      this.router.navigate([this.webstorage.sessionSt_frompage]);
    } else {
      this.router.navigate(['login']);
    }
  }

  // OTP Key Up event
  onKeyUpEvent(index, event) {
    var allowedValue = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]
    if (allowedValue.indexOf(event.target.value) === -1) {
      event.target.value = '';
      return false;
    }
    const pin = this.userForm.controls['pin1'].value.toString() + this.userForm.controls['pin2'].value.toString() + this.userForm.controls['pin3'].value.toString() + this.userForm.controls['pin4'].value.toString();
    if (pin.length === 4) {
      this.isOtpVerified = false;
      const otpinput = {
        ooc_guid: this.userId,
        str_ooc_otp: this.ecomservice.encryptWithKey(pin),
        customer_public_key: this.webstorage.localSt_olar_key,
        customer_client_key: this.webstorage.localSt_client_id
      };
      const url = EcomNetworkUtils.POST_VERIFY_OTP;
      this.ecomservice.httpPost(url, otpinput, '', true).subscribe((response) => {
        if (response.isSuccess) {
          this.isOtpVerified = true;
          this.showOtp = false;
          this.timerOn = false;
          this.errorMessage = undefined;
        } else {
          this.errorMessage = 'Invalid otp';
        }
      });
    } else {
      const eventCode = event.which || event.keyCode;
      if ((<HTMLInputElement>document.getElementById('pin' + index)).value.length === 1) {
        if (index !== 4) {
          document.getElementById('pin' + (index + 1)).focus();
        } else {
          document.getElementById('pin' + index).blur();
          const pin = this.userForm.controls['pin1'].value.toString() + this.userForm.controls['pin2'].value.toString() + this.userForm.controls['pin3'].value.toString() + this.userForm.controls['pin4'].value.toString();

        }
      }
      if (eventCode === 8 && index !== 1) {
        document.getElementById('pin' + (index - 1)).focus();
      }
    }
  }

  // On Focus event of Pin
  onFocusEvent(index) {
    for (let item = 1; item < index; item++) {
      const currentElement = (<HTMLInputElement>document.getElementById('pin' + item));
      if (!currentElement.value) {
        currentElement.focus();
        break;
      }
    }
  }

  // Method to redirect the user automatically to login page
  redirectUser(remaining) {
    this.redirect = true;
    //redirect
    let m = Math.floor(remaining / 60);
    let s = remaining % 60;
    m = m < 10 ? 0 + m : m;
    s = s < 10 ? 0 + s : s;
    if (document.getElementById('redirect')) {
      document.getElementById('redirect').innerHTML = ('0' + m).slice(-2) + ' : ' + ('0' + s).slice(-2);
    }
    remaining -= 1;
    if (remaining >= 0 && this.redirect) {
      let temp = this;
      setTimeout(function () {
        temp.redirectUser(remaining);
      }, 1000);
      return;
    }
    this.redirect = false;
    this.router.navigate(['login'],{ queryParams: { usermob: this.userForm.controls['mobile'].value.number } });
  }

  // Method to redirect the user to login screen
  login() {
    this.router.navigate(['login'],{ queryParams: { usermob: this.userForm.controls['mobile'].value.number } });
  }

  // Timer for OTP
  timer(remaining) {
    let m = Math.floor(remaining / 60);
    let s = remaining % 60;
    m = m < 10 ? 0 + m : m;
    s = s < 10 ? 0 + s : s;
    if (document.getElementById('timer')) {
      document.getElementById('timer').innerHTML = ('0' + m).slice(-2) + ' : ' + ('0' + s).slice(-2);
    }
    remaining -= 1;
    if (remaining >= 0 && this.timerOn) {
      let temp = this;
      this.timeoutFunc = setTimeout(function () {
        temp.timer(remaining);
      }, 1000);
      return;
    }
    if (!this.timerOn) {
      // Do validate stuff here
      return;
    }
    this.timerOn = false;
    this.resendOTP = true;
    // Do timeout stuff here
  }

  //input validation to enter only number
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onKeyUpOTP(event) {
    let value = event.target.value;
    if (value.length >= 4) {
      this.isOtpVerified = false;
      const otpinput = {
        ooc_guid: this.userId,
        str_ooc_otp: this.ecomservice.encryptWithKey(value),
        customer_public_key: this.webstorage.localSt_olar_key,
        customer_client_key: this.webstorage.localSt_client_id
      };
      const url = EcomNetworkUtils.POST_VERIFY_OTP;
      this.ecomservice.httpPost(url, otpinput, '', true).subscribe((response) => {
        if (response.isSuccess) {
          this.isOtpVerified = true;
          this.showOtp = false;
          this.timerOn = false;
          this.errorMessage = undefined;
        } else {
          this.errorMessage = 'Invalid otp';
        }
      });
    }
  }

}
